module.exports = __webpack_public_path__ + "static/media/bluesky.ef0cb7f4.svg";